/**************************************************
 * Nombre:       Dialogo_Carrito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, IconButton} from "@mui/material";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import {useFuncionesCarrito} from "../Hooks/useFuncionesCarrito";
import Formulario_Lista_Productos from "../Formularios/Formulario_Lista_Productos";
import {Close} from "@mui/icons-material";
import Formulario_Direccion from "../Formularios/Formulario_Direccion";
import {obtenerTotalProductos} from "../Utilidades/obtenerTotalProductos";
import {useState} from "react";
import Formulario_Opciones_Envio from "../Formularios/Formulario_Opciones_Envio";
import {usePagoWompi} from "../../Modulo_Wompi/Hooks/usePagoWompi";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {sacarPorcentaje} from "../Utilidades/sacarPorcentaje";
import {VALORENVIOGRATIS} from "../../Constantes";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {actualizarDoc} from "../../Servicios/BD/actualizarDoc";
import {valorMenosDescuento} from "../../Utilidades/valorMenosDescuento";
import {enviarMensajeNuevoPedido} from "../../CodCliente/enviarMensajeNuevoPedido";

const Dialogo_Carrito = ({cerrar}) => {
    const {productos} = useFuncionesCarrito()
    const {BotonNoVisible, pagar} = usePagoWompi()
    const {Pasos, obtenerEntidad} = usePasosFormularios({
        datos: {productos: productos, guardar: true},
        formularios: [
            Formulario_Lista_Productos,
            Formulario_Direccion,
            Formulario_Opciones_Envio
        ]
    })
    const {Cargador, iniciarCarga} = useCargador({logoRedondo: logo})
    const [cargando, setCargando] = useState(false)


    const subirDatosCarrito = async (e) => {


        setCargando(true)
        iniciarCarga('Seras redirigido a Wompi pagos seguros')
        let entidad = e
        entidad.fecha = new Date().getTime()
        entidad.estado = 'ABANDONADO'
        entidad.estadoPedido = 'Nuevo'
        entidad.valor = obtenerTotalProductos(entidad.productos)

        let num = await obtenerConsecutivo({col: 'consecutivos', id: 'pedidos'})
        if (!num.res) return


        //Guardar Cambios sucriptor
        if (entidad.descuento) {
            let obj = {
                cc: entidad.cc,
                ciudad: entidad.ciudad,
                departamento: entidad.departamento,
                celular: entidad.celular
            }
            let wc = [where('correo', '==', entidad.correo)]
            let doxCorreo = await obtenerColWheres({col: 'suscriptores', wheres: wc})
            await actualizarDoc({col: 'suscriptores', datos: obj, id: doxCorreo.data[0].id})
        }

        entidad.consecutivo = num.data
        await guardarDoc('pedidos', entidad)

        await aumentarConsecutivo({col: 'consecutivos', id: 'pedidos', actual: entidad.consecutivo})


        let valorProductos = obtenerTotalProductos(entidad.productos)
        let valorEnvio = parseInt(entidad.valorEnvio)

        let valor = valorProductos + valorEnvio

        if (entidad.descuento) {
            valor = valorProductos - valorMenosDescuento({valor: valorProductos, descuento: 10}) + valorEnvio
        }

        if (sacarPorcentaje({
            valor: valorProductos,
            maximo: VALORENVIOGRATIS
        }) >= 100) {
            valor = obtenerTotalProductos(entidad.productos)
        }


        pagar({
            valor: valor * 100,
            idVenta: entidad.consecutivo,
            correo: entidad.correo,
            celular: entidad.celular,
            direccion: entidad.direccion,
            cc: entidad.cc,
            nombre: entidad.nombres + ' ' + entidad.apellidos
        })

        enviarMensajeNuevoPedido({
            nombre: entidad.nombres + ' ' + entidad.apellidos,
            consecutivo: entidad.consecutivo,
            numero: entidad.celular,
            valor: entidad.valor,
            ciudad: entidad.ciudad,
        })

        setCargando(false)


    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
        >

            <BotonNoVisible/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                <IconButton onClick={() => cerrar()}><Close/></IconButton>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 3}}>
                <Pasos finalizar={subirDatosCarrito} cargando={cargando}/>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Carrito